const heroBanner = {
    init:() => {
        var el = $('.m7-a-hb__video-container');
        el.html('<video autoplay muted loop><source src="'+el.attr('data-video-url')+'" type="video/webm">Your browser does not support the video tag.</video>');
    }
};

export default heroBanner;